<template>
  <div class="grid-image-container">
    <div class="box-wrapper" v-if="!canDrag">
      <div
        :class="getBoxclass(index, false)"
        v-for="(item, index) in items"
        :key="item.id">
        <div>
          <ImageView
            :aspectRatio="getAspectRatio(item, index)"
            :source="getImageURL(item, index)"
            :imageSize="getImageSize(index)"
            :emptyMessageText="getEmptyMessageText(index)" />
        </div>
        <div class="card-content not-dragable" :class="getClassContent(item)">
          <span class="triangle"></span>
          <div class="header">{{ item.title }}</div>
          <div class="key">{{ item.contentCategory.key }}</div>
          <div
            v-if="canShowDescription(index) && item.description"
            class="description">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
    <dragable :list="items" class="box-wrapper" v-if="canDrag">
      <div
        @click="openEditModal(item)"
        :class="getBoxclass(index, true)"
        v-for="(item, index) in items"
        :key="item.id">
        <div>
          <ImageView
            :aspectRatio="getAspectRatio(item, index)"
            :source="getImageURL(item, index)"
            :imageSize="getImageSize(index)"
            :emptyMessageText="getEmptyMessageText(index)" />
        </div>
        <div class="card-content" :class="getClassContent(item)">
          <span class="triangle"></span>
          <div class="header">{{ item.title }}</div>
          <div class="key">{{ item.contentCategory.key }}</div>
          <div
            v-if="canShowDescription(index) && item.description"
            class="description">
            {{ item.description }}
          </div>
        </div>
      </div>
    </dragable>
  </div>
</template>

<script>
import _ from 'lodash';
import dragable from 'vuedraggable';
import ImageView from '@/image/ImageView.vue';

export default {
  props: {
    canDrag: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    dragable,
    ImageView,
  },
  methods: {
    getImageSize(index) {
      if (index > 1) {
        return 'cover640w640h';
      }
      return 'cover640w480h';
    },
    canShowDescription(index) {
      if (index > 1) {
        return false;
      }
      return true;
    },
    getAspectRatio(item, index) {
      const smallImageRatio = '1:1';
      const bigImageRatio = '4:3';
      if (index > 1) {
        return smallImageRatio;
      }
      return bigImageRatio;
    },
    getEmptyMessageText(index) {
      if (index > 1) {
        return 'ไม่มีรูปปกขนาดเล็ก';
      }
      return 'ไม่มีรูปปกขนาดใหญ่';
    },
    getImageURL(item, index) {
      const smallCoverImage = _.get(item, 'smallCoverImage', null);
      const bigCoverImage = _.get(item, 'bigCoverImage', null);
      if (index > 1) {
        // use small image instead
        return smallCoverImage;
      }
      return bigCoverImage;
    },
    openEditModal(item) {
      this.$emit('onEditItem', item);
    },
    handleEditButton() {
      this.$router.push(`${this.pageDesignerKey}/editgrid/${this.id}`);
    },
    getClassContent(item) {
      const content = _.get(item.contentCategory, 'key', '');
      switch (content) {
        case 'homeroom-homerun':
          return 'bg-altv-homeroom';
        case 'smart-classroom':
          return 'bg-altv-smart-classroom';
        case 'activity':
          return 'bg-altv-activity';
        case 'tutor-hub':
          return 'bg-altv-tutor-hub';
        case 'knowledge-pool':
          return 'bg-altv-knowledge-pool';
        case 'active-learning-news':
          return 'bg-altv-news';
        default:
          return 'bg-altv-homeroom';
      }
    },
    getBoxclass(index, isDragable) {
      const dragableClass = isDragable ? ' dragable' : '';
      if (index > 1) {
        return `card-box-small${dragableClass}`;
      }
      return `card-box-big${dragableClass}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/variables.scss";
@import "./src/assets/scss/themes/layouts/page.scss";
@import "./src/assets/scss/themes/components/section-container.scss";

.bg-altv-tutor-hub {
  background: $altv-tutor-hub;
}
.bg-altv-knowledge-pool {
  background: $altv-knowledge-pool;
}
.bg-altv-smart-classroom {
  background: $altv-smart-classroom;
}
.bg-altv-activity {
  background: $altv-activity;
}
.bg-altv-homeroom {
  background: $altv-homeroom;
}
.bg-altv-news {
  background: $altv-news;
}

.overlay {
  background: red;
  width: 100%;
  height: 100%;
  position: absolute;
}

.triangle {
  position: absolute;
  color: $white;
  margin-top: $spacer;
  margin-left: $spacer;
  border-top: $spacer / 2 solid;
  border-right: $spacer / 2 solid transparent;
}

.grid-image-container {
  .box-wrapper {
    display: flex;
    flex-wrap: wrap;
    // white-space: nowrap;
    flex-direction: row;
    align-items: center;
    margin-top: $spacer;
    font-family: $font-family-DBHeavent !important;
    .card-box-big {
      display: flex;
      flex-direction: column;
      flex: 0 0 calc(50% - 8px);
      margin-right: 16px;
      width: 100%;
      height: auto;
      background: $gray-200;
      margin-bottom: $spacer;
      .card-content {
        cursor: move;
        position: relative;
        margin-top: auto;
        width: 100%;
        height: 135px;
        .header {
          font-size: $font-size-base * 2;
          margin-top: $spacer * 2;
          margin-left: $spacer;
          position: absolute;
          color: $white;
        }
        .key {
          font-size: $font-size-base * 1.5;
          margin-top: $spacer * 0.25;
          margin-left: $spacer * 2;
          position: absolute;
          color: $white;
        }
        .description {
          font-size: $font-size-base * 1.5;
          margin-top: $spacer * 4;
          margin-left: $spacer;
          position: absolute;
          color: $white;
        }

        &.not-dragable {
          cursor: default;
        }
      }
      //need to manual cause last-child not working here
      &:nth-child(2) {
        margin-right: 0;
      }

      &.dragable {
        cursor: pointer;
      }
    }

    .card-box-small {
      display: flex;
      flex: 0 0 calc(25% - 8px);
      flex-direction: column;
      margin-right: 8px;
      margin-bottom: $spacer;
      width: 100%;
      height: auto;
      background: $gray-200;
      .card-content {
        cursor: move;
        position: relative;
        margin-top: auto;
        width: 100%;
        height: 65px;
        .header {
          font-size: $font-size-lg;
          margin-top: $spacer * 1.75;
          margin-left: $spacer;
          position: absolute;
          color: $white;
        }
        .key {
          margin-top: $spacer * 0.25;
          margin-left: $spacer * 2;
          position: absolute;
          color: $white;
          font-size: $font-size-base * 1.5;
        }
        &.not-dragable {
          cursor: default;
        }
      }

      //for smaller card
      &:nth-child(3) {
        margin-left: 0;
      }
      &:nth-child(5) {
        margin-left: 8px;
      }
      &:nth-child(6) {
        margin-right: 0;
      }

      &.dragable {
        cursor: pointer;
      }

    }
  }
}

@media screen and (max-width: 575.98px) {
  .grid-image-container {
    .box-wrapper {
      .card-box-big {
        flex: 0 0 calc(50% - 8px);
        margin-right: 16px;
        .card-content {
          cursor: move;
          position: relative;
          margin-top: auto;
          width: 100%;
          height: 105px;
          .header {
            font-size: $font-size-base * 1.5;
            margin-top: $spacer * 2;
            margin-left: $spacer;
            position: absolute;
            color: $white;
          }
          .key {
            font-size: $font-size-sm * 1.25;
            margin-top: $spacer * 0.5;
            margin-left: $spacer * 2;
            position: absolute;
            color: $white;
          }
          .description {
            font-size: $font-size-base;
            margin-top: $spacer * 4;
            margin-left: $spacer;
            position: absolute;
            color: $white;
          }
        }

        &.dragable {
          cursor: pointer;
        }
      }

      .card-box-small {
        flex: 0 0 calc(50% - 8px);
        margin-right: 16px;
        .card-content {
          cursor: move;
          position: relative;
          margin-top: auto;
          width: 100%;
          height: 105px;
          .header {
            font-size: $font-size-base * 1.5;
            margin-top: $spacer * 2;
            margin-left: $spacer;
            position: absolute;
            color: $white;
          }
          .key {
            font-size: $font-size-sm * 1.25;
            margin-top: $spacer * 0.5;
            margin-left: $spacer * 2;
            position: absolute;
            color: $white;
          }
        }

        //for smaller card
        &:nth-child(2n) {
          margin-right: 0;
        }
        &:nth-child(n) {
          margin-left: 0;
        }

        &.dragable {
          cursor: move;
        }

      }
    }
  }
}
</style>
